<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="User Payment Links">
        <v-row>
        <v-col cols="12" sm="6" md="4">
          <v-dialog ref="dialog" v-model="modal1" :return-value.sync="toDate" persistent width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field label="Date" v-model="toDate" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="toDate" scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="modal1 = false">
                Cancel
              </v-btn>
              <v-btn text color="primary" @click="$refs.dialog.save(toDate)">
                OK
              </v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-autocomplete key="id" v-model="selectedType" menu-props="auto" label="Select Status" @change="getUserRefences()" :items="PAYMENT_STATUS" item-text="text" item-value="value"> </v-autocomplete>
        </v-col>
      </v-row>
      <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
        <v-text-field
          :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
          v-model="search"
          append-icon="mdi-magnify"
          class="ml-auto mb-2"
          label="Search"
          hide-details
          single-line
          style="max-width:350px;"
        />
        <!-- <router-link :to="{ name: 'addFeeConcession' }" :class="{ 'd-flex justify-start': $vuetify.breakpoint.xs }">
          <v-btn elevation="1" :class="{ 'mt-2': $vuetify.breakpoint.xs }" color="accent">
            <v-icon left>mdi-plus</v-icon>
            Add
          </v-btn>
        </router-link> -->
      </v-card-text>

      <v-divider class=" my-0 " />
      <v-data-table
      disable-pagination
        :hide-default-footer="true"
        :headers="headers"
        :items="tblData"
        :search.sync="search"
      >
        <template v-slot:item.userName="{ item }"> {{ item.userName }}
        </template>
      </v-data-table>

        <template v-slot:no-data>
          <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
        </template>

         <v-col >
          <v-row>
            <v-col cols="4" sm="3">
              <v-select
                v-model="pageSize"
                :items="pageSizes"
                label="Items per Page"
                @change="handlePageSizeChange"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="9">
              <v-pagination
                v-model="page"
                :length="totalPages"
                :total-visible="10"
                @input="handlePageChange"
              ></v-pagination>
            </v-col>
          </v-row>
      </v-col>
    </material-card>
    <loading-icon :value="isLoading" />
  </v-container>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
import { mapGetters } from 'vuex'
import moment from 'moment'
export default {
  components: { MaterialCard },
  data () {
    return {
      isLoading: false,
      PAYMENT_STATUS: [
        {
          text: 'APPLICATION_FORM',
          value: 'APPLICATION_FORM'
        },
        { text: 'ADMISSION_FORM', value: 'ADMISSION_FORM' },

        { text: 'ADMISSION_FORM_FIRST_TIME', value: 'ADMISSION_FORM_FIRST_TIME' },
        { text: 'STUDENT_PROMOTION', value: 'STUDENT_PROMOTION' }
      ],
      selectedType: 'ADMISSION_FORM_FIRST_TIME',
      toDate: moment().format('YYYY-MM-DD'),
      modal1: false,
      baseUrl: '',
      search: '',
      tblData: [],
      total: 0,
      page: 1,
      totalPages: 0,
      pageSize: 10,
      pageSizes: [5, 10, 20],
      headers: [
        { text: 'Name', sortable: true, value: 'enquiry.studentFirstName' },
        { text: 'Enquiry Code', value: 'userName', align: 'center' },
        { text: 'Expiry Date', value: 'expiryDate', sortable: false },
        { text: 'Payment Link', value: 'urlEndpoint' },
        { text: 'Type', value: 'type' }

      ]
    }
  },
  async created () {
    this.getUserRefences()
    this.baseUrl = window.location.origin
  },
  computed: {
    ...mapGetters({

    })
  },
  watch: {
    toDate: async function (val) {
      await this.getUserRefences()
    }

  },
  methods: {

    getUserRefences: async function () {
      console.log(this.selectedType)
      if (this.selectedType === 'ADMISSION_FORM' || this.selectedType === 'STUDENT_PROMOTION') {
        this.headers = [
          { text: 'Name', sortable: true, value: 'studentAdmission.studentEnrollment.studentName' },
          { text: 'Enrollment Code', value: 'studentAdmission.studentEnrollment.enrollmentCode', align: 'center' },
          { text: 'Expiry Date', value: 'expiryDate', sortable: false },
          { text: 'Payment Link', value: 'urlEndpoint' },
          { text: 'Type', value: 'type' }

        ]
      } else {
        this.headers = [ { text: 'Name', sortable: true, value: 'enquiry.studentFirstName' },
          { text: 'Enquiry Code', value: 'userName', align: 'center' },
          { text: 'Expiry Date', value: 'expiryDate', sortable: false },
          { text: 'Payment Link', value: 'urlEndpoint' },
          { text: 'Type', value: 'type' }]
      }
      try {
        this.isLoading = true
        let query = `type=${this.selectedType}&offset=${this.page - 1}&limit=${this.pageSize}`
        if (this.toDate) {
          query = query + `&toDate=${this.toDate}`
        }
        let res = await http.get(`${CONSTANTS.API_URL}/api/user-references?${query}`)
        this.tblData = res.data.rows
        this.tblData.forEach(element => {
          element.urlEndpoint = this.baseUrl + '/' + element.urlEndpoint
        })

        this.totalPages = res.data ? Math.ceil(res.data.count / this.pageSize) : 0
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    handlePageChange (value) {
      this.page = value
      this.getUserRefences()
      this.isLoading = true
    },
    handlePageSizeChange (size) {
      this.pageSize = size
      this.page = 1
      this.getUserRefences()
    },
    okMsg (msg) {
      return this.$buefy.dialog.alert({
        type: 'is-success',
        message: msg,
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    }
  }
}
</script>

<style></style>
